// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file dailyitems/create_daily_item.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.CreateDailyItemRequest
 */
export class CreateDailyItemRequest extends Message<CreateDailyItemRequest> {
  /**
   * @generated from field: string item_name = 1;
   */
  itemName = "";

  /**
   * @generated from field: string item_type = 2;
   */
  itemType = "";

  constructor(data?: PartialMessage<CreateDailyItemRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreateDailyItemRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "item_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDailyItemRequest {
    return new CreateDailyItemRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDailyItemRequest {
    return new CreateDailyItemRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDailyItemRequest {
    return new CreateDailyItemRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDailyItemRequest | PlainMessage<CreateDailyItemRequest> | undefined, b: CreateDailyItemRequest | PlainMessage<CreateDailyItemRequest> | undefined): boolean {
    return proto3.util.equals(CreateDailyItemRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CreateDailyItemResponse
 */
export class CreateDailyItemResponse extends Message<CreateDailyItemResponse> {
  constructor(data?: PartialMessage<CreateDailyItemResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreateDailyItemResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDailyItemResponse {
    return new CreateDailyItemResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDailyItemResponse {
    return new CreateDailyItemResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDailyItemResponse {
    return new CreateDailyItemResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDailyItemResponse | PlainMessage<CreateDailyItemResponse> | undefined, b: CreateDailyItemResponse | PlainMessage<CreateDailyItemResponse> | undefined): boolean {
    return proto3.util.equals(CreateDailyItemResponse, a, b);
  }
}

